import { useEffect, useState } from 'react';
import { getTrades } from '../api';
import type { TradesResponse } from '../types';
import TradeTable from '../components/TradeTable';

export default function Trades() {
  const [data, setData] = useState<TradesResponse | null>(null);
  const [limit, setLimit] = useState(100);

  useEffect(() => {
    getTrades(limit).then(setData).catch(() => null);
  }, [limit]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold">Trade History</h2>
        <div className="flex items-center gap-2">
          <label className="text-xs text-trader-muted">Show:</label>
          <select
            value={limit}
            onChange={(e) => setLimit(Number(e.target.value))}
            className="bg-trader-card border border-trader-border rounded px-2 py-1 text-sm text-trader-text"
          >
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
            <option value={500}>500</option>
          </select>
          <button
            onClick={() => getTrades(limit).then(setData)}
            className="px-3 py-1 text-xs rounded border border-trader-border text-trader-muted hover:text-trader-text"
          >
            Refresh
          </button>
        </div>
      </div>

      <div className="bg-trader-card border border-trader-border rounded-lg p-4">
        <p className="text-xs text-trader-muted mb-3">
          Showing {data?.count ?? 0} trades
        </p>
        <TradeTable trades={data?.trades ?? []} />
      </div>
    </div>
  );
}
